import type { IconSvgObject } from './types';

const FileXCornerIcon: IconSvgObject = [
  ["path", { d: "M11.5 22H5.5C4.39543 22 3.5 21.1046 3.5 20V4C3.5 2.89543 4.39543 2 5.5 2H12.5L19.5 9V13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.5 2V7C12.5 8.10457 13.3954 9 14.5 9H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.4917 17L18 19.4958M18 19.4958L15.5 22M18 19.4958L20.5 22M18 19.4958L15.5083 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileXCornerIcon;
